import { PapiRequestDaSharedWatchUnsuggest, PapiDaSharedWatchUnsuggest } from '@wix/da-papi-types';

export const fakeUnsuggestResponse = ({
  params,
}: {
  params: PapiRequestDaSharedWatchUnsuggest;
}): PapiDaSharedWatchUnsuggest => {
  if (process.env.NODE_ENV !== 'production') {
    if (window.doError) {
      return {
        errorDescription: 'Failed to unsuggest user',
        success: false,
      };
    }
  }
  return { success: true };
};

export const fakeResponse =
  url =>
  ({ params }): any => {
    switch (url) {
      case 'watch/unsuggest':
        return fakeUnsuggestResponse({ params });
      default:
        return null;
    }
  };
